export default __webpack_public_path__ + "static/media/ve.143e6456.svg";